import clsx from 'clsx';
import React from 'react';

interface FilterChipProps {
    active: boolean;
    onClick: () => void;
    children: React.ReactNode;
    className?: string;
}

const FilterChip: React.FC<FilterChipProps> = ({
    active,
    onClick,
    children,
    className = '',
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={clsx(
                'rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors',
                active
                    ? 'bg-theme-primary text-theme-on-primary border-transparent'
                    : 'border-theme-border bg-theme-primary/10 text-theme-primary-text hover:bg-theme-primary/20 dark:text-neutral-100',
                className
            )}
        >
            {children}
        </button>
    );
};

export default FilterChip;
